export enum CacheKind {
  KnowledgeAPICache = 'KNOWLEDGE_API_CACHE'
}

/** Narrows a string, such as a route param, to a known cache kind. */
export const isCacheKind = (kind: string): kind is CacheKind =>
  Object.values<string>(CacheKind).includes(kind);

/**
 * given a "king", return the right confirmation message to display
 */
export function confirmationMessage(kind: string) {
  if (isCacheKind(kind) && kind === CacheKind.KnowledgeAPICache) {
    return 'This action will remove global knowledge api cache for this FOSSA instance. This will increase load on knowledge api database (component db) momentarily. This action is not reversible.';
  }

  return 'This action can have consequential impact on system load and user experience. This action may not be reversible, and may take very long time.';
}
